import { webAuth } from "$/lib/auth"

/**
 * For `@Auth`-guarded endpoints. Admin pages are not scoped to a store. Public
 * endpoints must use publicRequest from public-api.ts instead.
 */
export const { request } = webAuth.createApiClient()
